import { render, staticRenderFns } from "./DeleteRoleDialog.vue?vue&type=template&id=9b3713b4&"
import script from "./DeleteRoleDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteRoleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports